/** 雷云已退役的演出字段不再进入配置写入或客户端资源；其余参数原样保留。 */
export function cleanTileParams(tileId: string, params: Record<string, unknown>): Record<string, unknown> {
  const next = { ...params };
  if (tileId === "thunder") {
    delete next.shot;
    delete next.hitLabels;
    delete next.target;
  }
  return next;
}
